import * as LabeledText from '../../../ui/typo/LabeledText.tsx';
import * as LabeledToggle from 'dg-web-shared/tb-ui/toggle/LabeledToggle';
import { InputContext } from 'dg-web-shared/tb-ui/inputs/InputContext.ts';

export interface SelectableOption {
    description: string;
    id: number;
    selected: boolean;
}

interface Props {
    onSelect: (id: number) => void;
    selectableOptions: SelectableOption[];
    Label: (n: number) => string;
    multiSelection: boolean;
}

export function SelectableOptions({
    onSelect,
    selectableOptions,
    Label,
    multiSelection,
}: Props) {
    if (selectableOptions.length === 0) {
        return null;
    }
    return LabeledText.Factory(
        {
            context: InputContext.inverted,
            label: Label(selectableOptions.length),
            key: 'zones',
        },
        selectableOptions.map((z: SelectableOption) => {
            return LabeledToggle.Factory({
                context: InputContext.inverted,
                type: multiSelection
                    ? LabeledToggle.ToggleType.checkbox
                    : LabeledToggle.ToggleType.radio,
                key: z.id,
                label: z.description,
                selected: z.selected,
                onClick: (): void => onSelect(z.id),
            });
        }),
    );
}
